<div
  class="{{ ResizeHandle }} k-pos-absolute k-top-0 k-bottom-0 k-h-full"
  [attr.data-event-id]="plannerEventModel().id"
  [attr.data-user-id]="plannerEventModel().userId"
  style="opacity: 0"
  #dragHandle
  [ngClass]="{
    'left-handle': alignment() === EventDragHandleAlignment.Left,
    'k-left-0': alignment() === EventDragHandleAlignment.Left,
    'right-handle': alignment() === EventDragHandleAlignment.Right,
    'k-right-0': alignment() === EventDragHandleAlignment.Right,
  }"
>
  <kendo-svg-icon
    class="k-m-auto k-pos-absolute k-top-0 k-bottom-0"
    [icon]="handleDragIcon"
    [ngClass]="{
      'k-left-0': alignment() === EventDragHandleAlignment.Left,
      'k-right-0': alignment() === EventDragHandleAlignment.Right,
    }"
    size="small"
    [flip]="'vertical'"
  ></kendo-svg-icon>
</div>
